import _ from '@lodash';
import XAPPService from 'app/Core/services/XAPPService';
export const GET_EMPRESATAREFA = '[EMPRESATAREFA APP] GET EMPRESATAREFA';
export const EMPRESATAREFA_REMOVE = '[EMPRESATAREFA APP] REMOVE EMPRESATAREFA';
export const EMPRESATAREFA_WARNING = '[EMPRESATAREFA APP] EMPRESATAREFA WARNING';
export const EMPRESATAREFA_INFO = '[EMPRESATAREFA APP] EMPRESATAREFA INFO';
export const EMPRESATAREFA_ERROR = '[EMPRESATAREFA APP] EMPRESATAREFA ERROR';

const EmpresaTarefaListState = [
    'idempresatarefa',
    'idparent',
    'idpessoa',
    'tipo',
    'descricao',
    'prazo',
    'prazodescricao',
    'status',
    'statusdescricao',
    'statusregistro',
    'usuarionome',
    'datainsdescricao',
];
const AddState = [
    'idparent',
    'idpessoa',
    'descricao',
    'tipo',
    'prazo',
    'status',
];
const UpdateState = [
    'status',
];

export function list(_AAction, _AParams, _AID) {

    return (dispatch) => {

        var AConditionsAND = [{ "Campo": "empresatarefa.idparent", "Operador": "=", "Valor": _AID }];
        var AConditionsOR = [];
        var AActions = [];
        AActions = XAPPService.XappSelActionFactory(_AParams.empresa, "empresatarefa", AActions, "spvwempresatarefa", EmpresaTarefaListState, _AAction, AConditionsAND, AConditionsOR)

        XAPPService.XappSelAction(AActions, _AParams)
            .then((response) =>
                Promise.all([
                    dispatch({
                        type: GET_EMPRESATAREFA,
                        Name: (response.data && response.data.length > 0) ? JSON.parse(response.data)[0].name : "",
                        payload: (response.data && response.data.length > 0) ? JSON.parse(response.data)[0].data : "",
                    })
                ])
            )
            .catch(error => {
                return dispatch({
                    type: EMPRESATAREFA_ERROR,
                    payload: error
                });
            });
    };
}

export function save(_AValue, _AParams, _AID) {
    return (dispatch) => {

        var AConditionsAND = [{ "Campo": "idempresatarefa", "Operador": "=", "Valor": _AValue.idempresatarefa }];
        var AConditionsOR = [];
        var AActions = [];
        if (!_.isUndefined(_AValue.idempresatarefa) && !_.isNull(_AValue.idempresatarefa)) {
            AActions = XAPPService.XappDoActionFactory(_AParams.empresa, AActions, "empresatarefa", "ATUALIZAR", _AValue, "idempresatarefa", AConditionsAND, AConditionsOR, 1, UpdateState);
        }
        else {
            AActions = XAPPService.XappDoActionFactory(_AParams.empresa, AActions, "empresatarefa", "INSERIR", _AValue, "idempresatarefa", AConditionsAND, AConditionsOR, 1, AddState);
        }

        XAPPService.XappDoAction(AActions, _AParams, "DO")
            .then((response) => {
                if (response.warning) {
                    Promise.all([
                        dispatch({
                            type: EMPRESATAREFA_WARNING,
                            payload: response.warning
                        })
                    ]).then(() => dispatch(list("SELECIONAR", _AParams, _AID)))
                }
                else if (response.info) {
                    Promise.all([
                        dispatch({
                            type: EMPRESATAREFA_INFO,
                            payload: response.info
                        })
                    ]).then(() => dispatch(list("SELECIONAR", _AParams, _AID)))
                }
            }
            )
            .catch(error => {
                return dispatch({
                    type: EMPRESATAREFA_ERROR,
                    payload: error
                });
            });
    };
}

export function remove(_AValue, _AParams, _AID) {
    return (dispatch) => {

        var AConditionsAND = [{ "Campo": "idempresatarefa", "Operador": "=", "Valor": _AValue.idempresatarefa }];
        var AConditionsOR = [];
        var AActions = [];

        AActions = XAPPService.XappDoActionFactory(_AParams.empresa, AActions, "empresatarefa", "INATIVAR", "", "", AConditionsAND, AConditionsOR);

        XAPPService.XappDoAction(AActions, _AParams)
            .then((response) =>
                Promise.all([
                    dispatch({
                        type: EMPRESATAREFA_REMOVE
                    })
                ]).then(() => dispatch(list("SELECIONAR", _AParams, _AID)))
            )
            .catch(error => {
                return dispatch({
                    type: EMPRESATAREFA_ERROR,
                    payload: error
                });
            });
    };
}

export function clearEmpresaTarefa() {
    return {
        type: GET_EMPRESATAREFA,
        payload: null
    }
}